import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import PeakFeatureUpsellModal from '@alltrails/upsell/components/UpsellSystem/FeatureUpsell/PeakFeatureUpsellModal';
import headerImageSrc from './heatmaps-upsell-header.avif';

type Props = Pick<ComponentProps<typeof PeakFeatureUpsellModal>, 'isOpen' | 'onCloseRequest' | 'upsellTrigger' | 'trailId'>;

const HeatmapsUpsellModal = (modalProps: Props) => {
  return (
    <PeakFeatureUpsellModal
      {...modalProps}
      headerImageSrc={headerImageSrc}
      heading={<FormattedMessage defaultMessage="Get inspiration from trailgoers like you" />}
      promoEligibleHeading={<FormattedMessage defaultMessage="Try Heatmaps and more for free" />}
    />
  );
};

export default HeatmapsUpsellModal;
